import $ from 'jquery';

var StoreLocatorCustomWorkTimeFrom = (function () {
  'use strict';

  var init = function () {
    const $messageTypeChoice = $('#app_store_locator_pin_custom_work_time_messageType');
    const $storeLocatorPinChoice = $('#app_store_locator_pin_custom_work_time_storeLocatorPin').parent().parent();
    toggleFields($messageTypeChoice, $storeLocatorPinChoice);
    $messageTypeChoice.on('change', function () {
      toggleFields($messageTypeChoice, $storeLocatorPinChoice);
    });
  };

  var toggleFields = function ($messageTypeChoice, $storeLocatorPinChoice) {
    if ($messageTypeChoice.val() === 'iqos_store') {
      $storeLocatorPinChoice.show();
    } else {
      $storeLocatorPinChoice.hide();
    }
  };

  return {
    init: init,
  };
})();

export default StoreLocatorCustomWorkTimeFrom;
